var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalReturns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#84DCC8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.127L14.7009 11.1465H9L9.29912 10.127H15ZM12.3255 17L9.10557 13.0625L9.08798 12.3242H10.6891C11.1056 12.3242 11.4604 12.2656 11.7537 12.1484C12.0469 12.0283 12.2713 11.8496 12.4267 11.6123C12.5821 11.3721 12.6598 11.0703 12.6598 10.707C12.6598 10.1709 12.4985 9.75049 12.176 9.4458C11.8534 9.13818 11.3578 8.98437 10.6891 8.98437H9L9.29912 8H10.6891C11.4047 8 11.9912 8.11865 12.4487 8.35596C12.9091 8.59033 13.2493 8.9126 13.4692 9.32275C13.6921 9.72998 13.8035 10.1914 13.8035 10.707C13.8035 11.1729 13.7009 11.6021 13.4956 11.9946C13.2933 12.3843 12.9677 12.6978 12.5191 12.9351C12.0733 13.1724 11.4839 13.291 10.7507 13.291H10.7243L13.6979 16.9297V17H12.3255ZM15 8L14.7009 9.01953L10.2141 8.98437L10.5132 8H15Z",
    fill: "#1177BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2484 6.90156H17.8484C17.6024 6.90156 17.3984 6.69756 17.3984 6.45156V4.05156C17.3984 3.80556 17.6024 3.60156 17.8484 3.60156C18.0944 3.60156 18.2984 3.80556 18.2984 4.05156V6.00156H20.2484C20.4944 6.00156 20.6984 6.20556 20.6984 6.45156C20.6984 6.69756 20.4944 6.90156 20.2484 6.90156Z",
    fill: "#1177BD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8508 6.8985C17.7368 6.8985 17.6228 6.8565 17.5328 6.7665C17.3588 6.5925 17.3588 6.3045 17.5328 6.1305L20.5328 3.1305C20.7068 2.9565 20.9948 2.9565 21.1688 3.1305C21.3428 3.3045 21.3428 3.5925 21.1688 3.7665L18.1688 6.7665C18.0788 6.8565 17.9648 6.8985 17.8508 6.8985Z",
    fill: "#1177BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalReturns);
export default __webpack_public_path__ + "static/media/total-returns.02ba5e28279fed5610870a0dd7278f05.svg";
export { ForwardRef as ReactComponent };